module.exports = __webpack_public_path__ + "img/sharon.dfe07064.jpg";